//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn
    },
    data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src2: require('@/assets/images/wx_song_green.png'), // 送货的icon图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   deliveimgisload: 0,
                //   openimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   deliveimgisload: 1,
                //   openimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false,
        }
    },
    created() {
        document.title = '送货图片';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },
    methods: {
        getData() {
            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype,
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: apiUrl.deliveImgLading,
                data: data
            }, (resultData) => {
                this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                this.tableData = resultData.data.sonos || []
            }, (error) => {
                this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转查看页面，并且带些参数过去
            this.$router.push({
                name: routerName,
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,delivedoc为送货单证图片
                    companyId2: apiParams.companyId,
                    openId2: apiParams.openId,
                }
            })
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/siji/deliveImg/DeliveImgLading.vue